export default "__VITE_ASSET__BlF6eKuz__"